module.exports = __webpack_public_path__ + "img/back.03f9bd77.png";